import { type MaybeRef, unref } from "vue";

import type { components as OpenAPI } from "@/autogen/openapi";
import { ok } from "@/lib/openapi";

import api from "../../base";
import { useGenericListingQuery } from "../generic";
import { useNewsletterId } from "../utils";

export type WebhookPage = OpenAPI["schemas"]["WebhookPage"];
type WebhookStatus = OpenAPI["schemas"]["WebhookStatus"];

export const useWebhooksListingQuery = (opts?: {
  enabled?: MaybeRef<boolean>;
  status?: MaybeRef<WebhookStatus | undefined>;
}) => {
  const newsletterId = useNewsletterId();

  return useGenericListingQuery({
    queryKey: [newsletterId, "webhooks", "list", { status: opts?.status }],
    hydrateFrom: opts?.status ? undefined : "/webhooks",
    enabled: opts?.enabled,
    async fetch({ page, signal }) {
      const data = await ok(
        api.get("/webhooks", {
          signal,
          params: {
            query: {
              page: page,
              status: unref(opts?.status),
            },
          },
        })
      );

      return data;
    },
  });
};
